<template>
    <v-dialog
        max-width="500px"
        v-model="dialog"
    >
        <template v-slot:activator="{ on }">
            <v-btn
                icon
                v-on="on"
            >
                <v-icon small>
                    fa-filter
                </v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
        <span class="headline">
          Filter Table</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-select
                                :items="liveJobList"
                                @input="filterPersonnelListByJob"
                                item-text="name"
                                item-value="jobId"
                                label="Filter by Job"
                                multiple
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="[{id: 'isLive', name: 'Live'}, {id: 'notLive', name: 'Not Live'}]"
                                :value="personnelFilterByIsLiveState"
                                @input="filterPersonnelListByIsLive"
                                item-text="name"
                                item-value="id"
                                label="Filter by Live"
                                multiple
                            />
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    @click="close"
                    color="blue darken-1"
                    text
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {FILTER_PERSONNEL_BY_DEPARTMENT, FILTER_PERSONNEL_BY_IS_LIVE, FILTER_PERSONNEL_BY_JOB,} from "@/store/person/mutations";
    import {mapGetters} from "vuex";

    export default {
        name: "PersonnelTableFilterDialog",

        props: {
            jobList: {
                type: Array,
                required: true,
            },
            employmentTypeList: {
                type: Array,
                required: true,
            }
        },

        data: function () {
            return {
                dialog: false,
            };
        },

        computed: {
            ...mapGetters(["personnelFilterByIsLiveState", "liveJobList"])
        },

        methods: {
            filterPersonnelListByJob(value) {
                this.$store.commit(FILTER_PERSONNEL_BY_JOB, value);
            },
            filterPersonnelListByDepartment(value) {
                this.$store.commit(FILTER_PERSONNEL_BY_DEPARTMENT, value);
            },
            filterPersonnelListByIsLive(value) {
                this.$store.commit(FILTER_PERSONNEL_BY_IS_LIVE, value);
            },
            close() {
                this.dialog = false;
            }
        }
    }
</script>

<style scoped>

</style>
